
<template>
  <div class="footer">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'WheelFooter'
}
</script>
<style lang="scss" scoped>
</style>


